<template>
  <div class="backdrop">
    <div class="backdrop-top">
      <div class="title-box">
        <img src="../../../assets/images/return.png" @click="$router.go(-1)"><span>采购申请记账</span>
      </div>
      <div class="common head-wrapper">
        <div class="layout row">
          <label>商品种类：{{total_goods_kind}} 商品数量：{{total_goods_count}}</label>
        </div>
        <!-- 上传图片 -->
        <div class="uploadImg">
          <div class="uploadImgFile">
            <input class="uploadImg" @change="uploadFile" type="file">
          </div>
          <div class="uploadImgList" v-for="(image, image_key) in imageList" :key="image_key">
            <img class="img" :src="image" @click="previewImage(image)">
            <img class="del" @click="deleteImage(image_key)" src="../../../assets/images/repairman-del.png">
          </div>
        </div>
        <!-- 预览图片 -->
        <div class="previewimg" v-if="previewFile">
          <div @click="previewclose"></div>
          <img :src="previewimg">
        </div>
      </div>
      <div class="row-item" @click="tagClick">
        <label>申请标签</label>
        <input type="text" v-model="requisition_tag_name" placeholder="请选择申请标签" readonly>
        <img src="../../../assets/images/right_jt.png">
      </div>
      <div class="row-item" v-if="is_month">
        <label>采购年月</label>
        <input type="text" v-model="date_time" placeholder="请选择采购年月" @click="selectData">
        <mt-datetime-picker ref="datePicker" type="date" v-model="pickerValue" @confirm="handleConfirm"></mt-datetime-picker>
      </div>
      <div class="row-item" @click="typeClick">
        <label>申请分类</label>
        <input type="text" v-model="requisition_type_name" placeholder="请选择申请分类" readonly>
        <img src="../../../assets/images/right_jt.png">
      </div>
      <div class="row-radio" v-if="radioCount">
        <label>是否定量</label>
        <el-radio-group v-model='checked' @change="updateChecked">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </div>
      <div class="row-radio" v-if="radioAmount">
        <label>是否定额</label>
        <el-radio-group v-model='checked' @change="updateChecked">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </div>
      <div class="quota-amount" v-if="amountValue">
        <div>定额金额<input type="numder" ref="input" v-model="quota_amount" /></div>
      </div>
      <div class="common remarks-wrapper">
        <div>备注</div>
        <div class="remarks-textarea">
          <textarea v-model="remarks" placeholder="请输入备注"></textarea>
        </div>
      </div>
    </div>
    <div class="backdrop-bottom">
      <button class="entry-btn" @click="commit">保存草稿</button>
      <!-- <button class="entry-btn">入账</button> -->
    </div>
    <!-- 选择仓库弹出框 -->
    <div class="warehouselist" v-if="warehouseList">
      <div class="warehouselist-top" @click="clickBlank"></div>
      <div class="warehouselist-bottom">
        <el-tree :data="warehouseData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectStorage"></el-tree>
      </div>
    </div>
    <!-- 申请标签 -->
    <div class="select-mask" v-if="tagPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">申请标签<img class="close-mask" @click="tagClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="tagData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectTag"></el-tree>
        </div>
      </div>
    </div>
    <!-- 申请分类 -->
    <div class="select-mask" v-if="typePopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">申请分类<img class="close-mask" @click="typeClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="typeData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectType"></el-tree>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'RequisitionAdd',
  metaInfo: {
    title: '采购申请记账'
  },
  computed: {
    ...mapState(['villageId', 'villageName', 'memberId'])
  },
  data () {
    return {
      imageList: [], // 保存图片集合
      imageListId: [], // 选中的图片id
      previewimg: '', // 预览图片
      previewFile: false, // 预览默认关闭
      maxSize: 500, // 上传图片限制最大为500kb
      formData: '',
      access_token: '', // tob access_token
      warehouseList: false, // 选择仓库弹出框
      warehouseData: [],
      remarks: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      total_goods_kind: 0,
      total_goods_count: 0,
      requisition_info: [],
      operate_log: [],
      typePopup: false,
      tagPopup: false,
      requisition_tag_name: '',
      requisition_type_name: '',
      requisition_tag: '',
      requisition_type: '',
      radioCount: false,
      radioAmount: false,
      checked: '',
      tagData: [{id: 1, label: '应急采购'}, {id: 2, label: '月度采购'}],
      typeData: [{id: 1, label: '办公用品'}, {id: 2, label: '保洁'}, {id: 3, label: '工程'}, {id: 4, label: '绿化'}, {id: 5, label: '秩序'}, {id: 6, label: '固定资产'}],
      is_quota_count: 0,
      is_quota_amount: 0,
      amountValue: false,
      quota_amount: '',
      selecte_requisition_type: '',
      date_time: '',
      pickerValue: new Date(),
      is_month: false
    }
  },
  created () {
    console.log('this.$route-add:')
    console.log(this.$route)
    this.getAccessToken()
    this.requisition_id = this.$route.query.requisition_id
    this.selecte_goods_lists = JSON.parse(this.$route.query.selecteLists)
    // 申请分类（龙翔集团）
    if (this.$route.query.requisition_type) {
      this.selecte_requisition_type = this.$route.query.requisition_type
      this.selectType(this.typeData[this.selecte_requisition_type - 1])
    }
    if (this.selecte_goods_lists === undefined || Object.keys(this.selecte_goods_lists).length === 0) {
      this.$toast({
        message: '请选择商品',
        duration: 5000
      })
      // this.$router.push({name: 'SelecteGoods', query: {repair_id: this.repair_id, delivery_type_id: this.delivery_type_id}})
    } else {
      this.total_goods_kind = Object.keys(this.selecte_goods_lists).length// 商品种类
      for (var key of Object.keys(this.selecte_goods_lists)) {
        this.total_goods_count = parseFloat(this.selecte_goods_lists[key]['goods_count']) + parseFloat(this.total_goods_count) // 总件数
      }
    }
    if (this.requisition_id !== undefined) {
      this.getRequisitionInfo()
    }
  },
  methods: {
    getRequisitionInfo () {
      this.axios.post('/wechat/Purchase/getRequisitionInfo', {
        member_id: this.memberId,
        village_id: this.villageId,
        requisition_id: this.requisition_id
      }).then((res) => {
        console.log('getRequisitionInfo:')
        console.log(res.data)
        if (res.data.status === 1) {
          this.requisition_info = res.data.data
          this.remarks = this.requisition_info.remark
          this.requisition_tag_name = this.tagData[parseInt(this.requisition_info.requisition_tag) - 1]['label']
          this.requisition_type_name = this.typeData[parseInt(this.requisition_info.requisition_type) - 1]['label']
          this.requisition_tag = this.requisition_info.requisition_tag
          if (this.requisition_tag === 2) {
            this.is_month = true
          }
          if (this.requisition_info.month) {
            this.date_time = this.requisition_info.year + '-' + this.requisition_info.month
            this.pickerValue = this.requisition_info.year + '-' + this.requisition_info.month + '-1'
          }
          this.requisition_type = this.requisition_info.requisition_type
          this.is_quota_amount = this.requisition_info.is_quota_amount
          this.is_quota_count = this.requisition_info.is_quota_count
          this.quota_amount = this.requisition_info.quota_amount
          if (this.requisition_type === 2) {
            this.radioCount = true
            this.radioAmount = false
            this.amountValue = false
            this.checked = this.requisition_info.is_quota_count
          } else if (this.requisition_type === 1 || this.requisition_type === 3) {
            this.radioCount = false
            this.radioAmount = true
            this.checked = this.requisition_info.is_quota_amount
            if (this.checked === 1) {
              this.amountValue = true
            } else {
              this.amountValue = false
            }
          } else {
            this.radioCount = false
            this.radioAmount = false
            this.amountValue = false
            this.checked = ''
          }
          if (this.requisition_info.pictures) {
            for (var j = 0; j < this.requisition_info.pictures.length; j++) {
              this.imageList = this.imageList.concat(this.requisition_info.pictures[j]['picture_url'])
              this.imageListId = this.imageListId.concat(this.requisition_info.pictures[j]['picture_id'])
            }
          }
        }
      }).catch(() => {
        this.loading = false
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    commit () {
      if (this.goods_lists === {}) {
        this.$toast({
          message: '请选择商品',
          duration: 3000
        })
        return false
      }
      if (this.requisition_tag === '') {
        this.$toast({
          message: '请选择申请标签',
          duration: 3000
        })
        return false
      }
      if (this.requisition_type === '') {
        this.$toast({
          message: '请选择申请分类',
          duration: 3000
        })
        return false
      }
      var info = ''
      if (this.requisition_type === 2 && this.checked === '') {
        info = '请选择是否定量'
        this.$toast({
          message: info,
          duration: 3000
        })
        return false
      } else if ((this.requisition_type === 1 || this.requisition_type === 3) && this.checked === '') {
        info = '请选择是否定额'
        this.$toast({
          message: info,
          duration: 3000
        })
        return false
      }
      console.log('提交')
      console.log(this.requisition_tag)
      console.log(this.requisition_type)
      console.log(this.is_quota_count)
      console.log(this.is_quota_amount)
      console.log(this.imageListId)
      console.log(this.selecte_goods_lists)
      console.log(this.date_time)
      this.axios.post('/wechat/Purchase/addRequisition', {
        member_id: this.memberId,
        village_id: this.villageId,
        requisition_id: this.requisition_id,
        imageListId: this.imageListId,
        remarks: this.remarks,
        goods_lists: this.selecte_goods_lists,
        requisition_tag: this.requisition_tag,
        requisition_type: this.requisition_type,
        is_quota_count: this.is_quota_count,
        is_quota_amount: this.is_quota_amount,
        quota_amount: this.quota_amount,
        requisition_month: this.date_time
      }).then((res) => {
        console.log(res)
        if (res.data.status === 1) {
          this.$toast({
            message: '操作成功',
            duration: 5000
          })
          this.$router.push({name: 'RequisitionList'})
          // this.$router.go(-1)
        } else {
          this.$toast({
            message: res.data.info,
            duration: 5000
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    selectStorage (data) {
      this.clickBlank()
    },
    warehouseClick () {
      this.warehouseList = true
    },
    clickBlank () {
      this.warehouseList = false
      this.tagPopup = false
      this.typePopup = false
    },
    // 选择上传图片
    uploadFile (e) {
      if (this.imageList.length < 9) {
        let that = this
        var files = e.target.files[0]

        var reader = new FileReader()
        reader.readAsDataURL(files)
        // 监听文件读取结束后事件
        reader.onloadend = function (e) {
          // var dx = (e.total / 1024) / 1024
          // if (dx >= 2) {
          //   alert('文件大小大于2M')
          //   return
          // }
          that.imageList.push(e.target.result)

          let img = new Image()
          img.src = reader.result
          img.onload = () => {
            // 以上是将选择的图片展示出来
            let originWidth = img.naturalWidth
            let originHeight = img.naturalHeight
            let originSize = files.size / 1024 // 计算图片多少kb
            // 将图片绘制到canvas上进行压缩
            let canvas = document.createElement('canvas')
            let context = canvas.getContext('2d')
            let maxSize = that.maxSize
            if (originSize <= maxSize) {
              that.formData = new FormData() // 声明一个FormData对象
              that.formData.append('file', files)
            } else {
              let mul = originSize / maxSize
              let targetWidth = originWidth / mul
              let targetHeight = originHeight / mul
              canvas.width = targetWidth
              canvas.height = targetHeight
              context.clearRect(0, 0, targetWidth, targetHeight) // 清除画布
              context.drawImage(img, 0, 0, targetWidth, targetHeight) // 画图

              let dataURL = canvas.toDataURL('image/jpeg') // 将其转化成base64字符串
              let blob = that.dataURItoBlob(dataURL) // 转化为blob格式
              var fileName = new Date().getTime() + '.jpeg'

              that.formData = new FormData() // 声明一个FormData对象
              that.formData.append('file', blob, fileName)
            }
            var options = { // 设置axios的参数
              url: '/api/Upload/uploadpicture?access_token=' + that.access_token,
              data: that.formData,
              method: 'post',
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
            that.axios(options).then((res) => {
              that.imageListId = that.imageListId.concat(res.data.data.id)
              console.log('that.imageList')
              console.log(that.imageListId)
              console.log(that.imageList)
            })
          }
        }
      } else {
        this.$toast({
          message: '最多选择9张图片',
          duration: 5000
        })
      }
      e.target.value = '' // 解决input type=file 同一个文件二次上传无效的问题
    },
    // base64格式转化为blob对象
    dataURItoBlob (dataURI) {
      let byteString = atob(dataURI.split(',')[1])
      let mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
      let ab = new ArrayBuffer(byteString.length)
      let ia = new Uint8Array(ab)
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ab], { type: mimeString })
    },
    // 删除上传图片
    deleteImage (e) {
      this.imageList.splice(e, 1)
      this.imageListId.splice(e, 1)
    },
    // 预览图片
    previewImage (e) {
      this.previewFile = true
      this.previewimg = e
    },
    // 关闭预览
    previewclose () {
      this.previewFile = false
    },
    // 获取tob accessToken
    getAccessToken () {
      this.axios.get('/wechat/repair/tobAccessToken')
        .then((res) => {
          if (res.data.status === 1) {
            this.access_token = res.data.data.access_token
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    updateChecked (val) {
      if (this.radioCount === true) {
        this.is_quota_count = val
        this.is_quota_amount = 0
        this.amountValue = false
        this.quota_amount = ''
      }
      if (this.radioAmount === true) {
        this.is_quota_count = 0
        this.is_quota_amount = val
        if (val === 1) {
          this.amountValue = true
        } else {
          this.amountValue = false
          this.quota_amount = ''
        }
      }
    },
    selectTag (data) {
      this.requisition_tag = data.id
      this.requisition_tag_name = data.id === 0 ? '' : data.label
      if (data.id === 2) {
        this.is_month = true
      } else {
        this.date_time = ''
        this.is_month = false
      }
      this.clickBlank()
    },
    selectType (data) {
      this.requisition_type = data.id
      this.requisition_type_name = data.id === 0 ? '' : data.label
      this.is_quota_count = 0
      this.is_quota_amount = 0
      this.checked = ''
      this.amountValue = false
      this.quota_amount = ''
      // if (data.id === 0) {
      //   this.radioCount = false
      //   this.radioAmount = false
      // }
      if (data.id === 2) {
        this.radioCount = true
        this.radioAmount = false
      } else if (data.id === 1 || data.id === 3) {
        this.radioCount = false
        this.radioAmount = true
      } else {
        this.radioCount = false
        this.radioAmount = false
      }
      this.clickBlank()
    },
    // 点击申请标签
    tagClick () {
      this.tagPopup = true
    },
    // 点击申请分类
    typeClick () {
      if (this.selecte_requisition_type === '') {
        this.typePopup = true
      }
    },
    // 关闭申请标签
    tagClose () {
      this.tagPopup = false
    },
    // 关闭申请分类
    typeClose () {
      this.typePopup = false
    },
    // 打开时间选择器
    selectData () {
      this.$refs['datePicker'].open()
      var pickerSlot = document.getElementsByClassName('picker-slot')
      pickerSlot[2].style.display = 'none'
    },
    // 选择时间点击确定按钮
    handleConfirm (val) {
      let date = val
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      month = month > 9 ? month : '0' + month
      let resDate = year + '-' + month
      this.date_time = resDate
    }
  }
}
</script>
<style scoped>
.common {
  padding: 10px 15px;
}
.backdrop {
  overflow: hidden;
}
.backdrop-top {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.head-wrapper {
  font-size: 15px
}
.head-wrapper .row {
  line-height: 28px;
}
.head-wrapper .row label {
  width: 125px;
}
.head-wrapper .warearrow {
  width: 12px;
  height: 12px;
  margin-left: 15px;
}
.remarks-wrapper {
  color: #969696;
}
.remarks-wrapper .remarks-textarea {
  display: flex;
}
.remarks-wrapper .remarks-textarea textarea {
  flex: 1;
  border: none;
  padding: 15px 0;
  outline: none;
  color: #c2c2c2;
  font-size: 14px;
  min-height: 50px;
}
.remarks-wrapper .remarks-textarea textarea::-webkit-input-placeholder{
  color:#c2c2c2;
}
.backdrop-bottom {
  height: 50px;
  background-color: #ffffff;
  display: flex;
}
.backdrop-bottom button {
  flex: 1;
  height: 50px;
  line-height: 49px;
  background-color: #f0f1f3;
  border-radius: none;
  border: none;
  color: #45454d;
  font-size: 15px;
}
.backdrop-bottom .entry-btn {
  background-color: #ff7c12;
  color: #ffffff;
}
.warehouselist {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 99;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 15px;
}
.warehouselist .warehouselist-bottom {
  background-color: #ffffff;
  width: 100%;
  position: absolute;
  bottom: 0;
}
.warehouselist-top {
  width: 100%;
  height: 100%;
}
.warehouselist .warehouselist-bottom label {
  display: block;
  padding: 8px 15px;
}
.select-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.select-mask .select-mask-blank {
  width: 100%;
  height: 100%;
}
.select-mask .select-mask-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  font-size: 15px;
  height: 300px;
}
.select-mask .select-mask-inner .select-mask-content {
  padding: 0 15px;
}
.select-mask .select-mask-inner .head-mask {
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
}
.select-mask .select-mask-inner .head-mask .close-mask {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 10px;
}
.select-mask .select-mask-inner .select-mask-content .level {
  border-bottom: 1px solid #f6f6f6;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  position: relative;
}
.select-mask .select-mask-inner .select-mask-content label {
  display: block;
  border-bottom: 1px solid #f6f6f6;
  padding: 5px 15px;
}
.backdrop-top .row-item {
  display: flex;
  /* margin: 0 15px; */
  padding: 10px 15px;
  border-bottom: 1px solid #f6f6f6;
  font-size: 15px;
  background-color: #ffffff;
}
.backdrop-top .row-item input {
  flex: 1;
  width: 100%;
  border: none;
  outline: none;
  font-size: 15px;
  text-align: right;
  padding: 0;
}
.backdrop-top .row-item img {
  width: 12px;
  height: 12px;
  vertical-align: top;
  padding: 5px 0 0 5px;
}
.row-radio {
  padding: 15px 15px;
}
.row-radio label {
  margin-right: 15px;
}
.quota-amount{
  width: 100%;
  padding: 10px 15px;
}
.quota-amount input{
  border-radius: 15px;
  border: none;
  height: 28px;
  width: 60%;
  margin-left: 15px;
  background-color: #f7f7f7;
  outline: none;
  padding: 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/purchase/RequisitionAdd.vue